"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var processSelector = function (item, selector) {
    if (typeof selector === 'string') {
        return item[selector];
    }
    if (typeof selector === 'function') {
        return selector(item);
    }
    return item;
};
exports.default = processSelector;
